<template>
  <div id="single-service-wrapper">
    <div
      id="single-service-content"
      class="SingleService single-service-scroller"
    >
      <!-- SEO TITLE -->
      <div
        v-if="$store.state.isMobile && content.top_bar_mobile"
        :style="`background : ${customColor};`"
        class="verticalSpaceMobile mobile-top-scroll"
      />

      <div
        v-if="content.top_bar_desktop && !$store.state.isMobile"
        :style="`background : ${customColor};`"
        class="verticalSpaceDesktop desktop-top-scroll"
      />

      <div
        class="SingleService__header"
        @click="showModalVideo"
      >
        <img
          v-if="$store.state.isMobile && content.header_image_mb"
          :data-src="getImageKitURL(content.header_image_mb, 1, content.image_type,false, position)"
          :src="getImageKitURL(content.header_image_mb, 1, content.image_type,false, position)"
          :alt="content.header_image_mb.alt"
          class="SingleService__header--image"
        >
        <img
          v-else
          :data-src="getImageKitURL(content.header_image, 1, content.image_type,false, position)"
          :src="getImageKitURL(content.header_image, 1, content.image_type,false, position)"
          :alt="content.header_image.alt"
          class="SingleService__header--image"
          @mouseover="mouseEnter"
          @mouseleave="mouseLeave"
        >
        <span
          v-if="$store.state.isMobile && content.vimeo_id"
          class="playMobile"
        >
          <img
            src="/fonts/play_white.png"
            alt="indicators"
          >
        </span>
      </div>



      <main class="SingleService__content">
        <div class="SingleService__left">
          <div class="SingleService__subtitle main-text grey">
            <InertiaLink
              :href="`/services/`"
              class="grey"
            >
              Services
            </InertiaLink>
            <p v-if="content.service_category && content.service_category.length > 0">
              <span class="orange">
                –
              </span>
              {{ content.service_category[0].title }}
            </p>
            <!-- logo_white_mb_on_scroll: {{ content.logo_white_mb_on_scroll }} <br>
            logo_white_on_scroll: {{ content.logo_white_on_scroll }} <br>
            logo_white_mb: {{ content.logo_white_mb }} <br>
            white_logo: {{ content.white_logo }} <br>
            transparent_header: {{ content.transparent_header }} <br>
            top_bar_mobile: {{ content.top_bar_mobile }} <br>
            top_bar_desktop: {{ content.top_bar_desktop }} <br>
            bg_top_bar: {{ content.bg_top_bar }} <br> -->
          </div>
          <h1 class="SingleService__title">
            {{ content.title }}<span class="orange">.</span>
          </h1>
          <h2 class="SingleService__subtitle main-text orange">
            {{ content.subtitle }}
          </h2>
        </div>
        <div class="SingleService__right">
          <div
            class="SingleService__description main-text"
            v-html="content.description"
          />
        </div>
      </main>

      <section
        v-if="content.featured_projects"
        class="Related scroll-related-projects"
      >
        <h3 class="section-title ">
          Featured projects<span class="orange">.</span>
        </h3>
        <div class="Related__container">
          <div
            v-for="(project, index) in visibleFeaturedProjects"
            :key="`project${index}`"
            class="Related__item"
          >
            <InertiaLink
              v-if="project.news_filters && project.news_filters?.length > 0"
              class="Related__item--link"
              :href="`/press/${project.slug}/`"
            >
              <div class="Related__item--image-container">
                <div
                  v-if="project.thumb_4_5_video"
                  class="indexProject__background-video--overlay"
                />
                <div
                  v-if="project.thumb_4_5_video"
                  class="indexProject__background-video"
                  data-nosnippet
                >
                  <iframe
                    :src="`https://player.vimeo.com/video/${project.thumb_4_5_video}?background=1`"
                    frameborder="0"
                    allow="autoplay"
                    width="100%"
                    height="100%"
                    :title="project.title"
                  />
                </div>
                <img
                  v-if="project.thumbnail_4_5"
                  :data-src="getImageKitURL(project.thumbnail_4_5, 3, project.image_type, false, position)"
                  :src="getImageKitURL(project.thumbnail_4_5, 3, project.image_type,true, position)"
                  class="Related__item--image"
                  :alt="project.title"
                >
                <img
                  v-else
                  :src="`${$store.state.baseimageUrl}default-thumb-4-5.png`"
                  class="Related__item--image"
                  alt="default image"
                >
              </div>
              <h3 class="small-title grey-dark mobile-padding">
                <span
                  v-if="project.published == 0 && $page.props.auth.user"
                  class="orange"
                >*</span>{{ project.title }}
              </h3>
              <h4 class="regular-text orange mobile-padding">
                <span
                  v-for="(category, idx) in customCategory(project.news_filters)"
                  :key="category"
                >
                  <span v-if="idx > 0">, </span>
                  {{ category }}
                </span>
              </h4>
            </InertiaLink>

            <InertiaLink
              v-else
              class="Related__item--link"
              :href="`/work/${project.slug}/`"
            >
              <div class="Related__item--image-container">
                <div
                  v-if="project.thumb_4_5_video"
                  class="indexProject__background-video--overlay"
                />
                <div
                  v-if="project.thumb_4_5_video"
                  class="indexProject__background-video"
                  data-nosnippet
                >
                  <iframe
                    :src="`https://player.vimeo.com/video/${project.thumb_4_5_video}?background=1`"
                    frameborder="0"
                    allow="autoplay"
                    width="100%"
                    height="100%"
                    :title="project.title"
                  />
                </div>
                <img
                  v-if="project.thumbnail_4_5"
                  :data-src="getImageKitURL(project.thumbnail_4_5, 3, project.image_type, false)"
                  :src="getImageKitURL(project.thumbnail_4_5, 3, project.image_type,false)"
                  class="Related__item--image"
                  :alt="project.title"
                >
                <img
                  v-else
                  :src="`${$store.state.baseimageUrl}default-thumb-4-5.png`"
                  class="Related__item--image"
                  alt="default image"
                >
              </div>
              <h5 class="indexProject__client mobile-padding">
                {{ project.client_subtitle }}
              </h5>
              <h3 class="small-title grey-dark mobile-padding">
                <span
                  v-if="project.published == 0 && $page.props.auth.user"
                  class="orange"
                >*</span>{{ project.title }}
              </h3>
              <h4 class="regular-text orange mobile-padding">
                {{ project.subtitle }}
              </h4>
            </InertiaLink>
          </div>
          <div
            v-if="content.search_button"
            class="Related__item"
          >
            <InertiaLink

              class="Related__item--link"
              :href="content.search_button"
            >
              <div class="Related__item--image-container">
                <img
                  :src="`${$store.state.baseimageUrl}binalogue-view-more.png`"
                  class="Related__item--image"
                  alt="view more"
                >
              </div>

              <h3
                v-if="content.search_button_text"
                class="small-title grey-dark mobile-padding"
              >
                {{ content.search_button_text }}
              </h3>
            </InertiaLink>
          </div>
        </div>
      </section>





      <span id="single-service-content-footer" />
      <TheFooter />
    </div>

    <span
      v-if="content.vimeo_id"
      class="cursor cursorPlay"
    >
      <TextPlay />
    </span>
  </div>
</template>

<script>
/* Vendor */
import { nextTick } from 'vue';
import { InertiaLink } from "@inertiajs/inertia-vue3";

/* Helpers */
import { mainLayout } from "@/helpers/vue-layouts";
import seo from "@/helpers/seo";

/* Mixins */
import page from "@/mixins/page";
import imageKit from "@/mixins/image-kit";
import scrollGlobal from "@/mixins/scroll-global";
import loader from "@/mixins/loader";

export default {
  components: {
    InertiaLink
  },

  mixins: [page, scrollGlobal, loader, imageKit],

  layout: mainLayout,

  props: {
    position: {
      type: Number,
      default: 1000
    },
    content: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      headerColorinit: null,
      bgScrollAnimation:null,
    };
  },

  computed: {
    customColor() {
      if (this.content.bg_top_bar) {
        return this.content.bg_top_bar;
      } else {
        return "transparent";
      }
    },
    visibleFeaturedProjects() {
      return this.content.featured_projects.filter(
        (project) => project.published == 1 || this.$page.props.auth.user
      );
    }
  },

  created() {
    seo.seoContent(this.content);
  },

  mounted() {
    this.$nextTick(() => {
      console.log('init load images in page' );
      this.imagesToPreload = document.querySelectorAll("img");
      console.log('single service imgs',this.imagesToPreload  );
      this.getBackgroundImagesUrl();
      this.loadImages();

      if (this.content.vimeo_id) {
        this.cursorAnimations();
      }
    });
  },

  beforeUnmount() {
    this.bgScrollAnimation.scrollTrigger.kill();
    this.$gsap.to('.hideInAvatar', {opacity:1, duration:0.4});
  },

  methods: {
    init() {
      console.log('init');


      if (this.$store.state.isMobile) {
        if (this.content.white_logo_mb) {
          this.toggleMenuColor("white", 0, 0);
        } else {
          this.toggleMenuColor("black", 0, 0);
        }
      } else {
        if (this.content.white_logo) {
          this.toggleMenuColor("white", 0, 0);
        } else {
          this.toggleMenuColor("black", 0, 0);
        }
      }

      if (this.$store.state.isMobile && !this.content.transparent_header) {
        this.$gsap.to(".showBgHeader", { height: "100%", duration: 0 });
      }

      setTimeout(() => {
        this.setScroller('#single-service-wrapper', '#single-service-content' );

        // HEADER ANIMATIONS
        this.bgScrollAnimation = this.$gsap.to('.showBgHeader', {
          scrollTrigger: {
            trigger: '#single-service-content',
            markers: false,
            onEnter: this.updateHeaderState,
            onEnterBack: this.updateHeaderStateBack,
            start: '50px top',
            end: 'top bottom',
            toggleActions: 'play none reverse none',
          },
          height: '100%',
          duration: 0.2,
          ease: 'Power2.out',
        });

      }, 500);
      // this.$gsap.to('.hideInAvatar', {opacity:0, duration:0.4});
    },

    updateHeaderState() {
      if (this.$store.state.isMobile) {
        if (this.content.logo_white_mb_on_scroll) {
          this.toggleMenuColor("white", 0.2, 0);
        } else {
          this.toggleMenuColor("black", 0.2, 0);
        }
      } else {
        if (this.content.logo_white_on_scroll) {
          this.toggleMenuColor("white", 0.2, 0);
          console.log('updateHeaderState');
        } else {
          this.toggleMenuColor("black", 0.2, 0);
        }
      }
    },

    updateHeaderStateBack() {
      if (this.$store.state.isMobile) {
        if (this.content.menu_white_mobile) {
          this.toggleMenuColor("white", 0.2, 0);
        } else {
          this.toggleMenuColor("black", 0.2, 0);
        }
      } else {
        if (this.content.menu_white) {
          this.toggleMenuColor("white", 0.2, 0.4);
        } else {
          this.toggleMenuColor("black", 0.2, 0.4);
        }
      }
    },

    showModalVideo() {
      console.log('showModalVideo');
      this.$store.state.video_id = this.content.vimeo_id;

      if(this.content.vimeo_id){
        if(this.showVideoModal){
          setTimeout(() => {
            // this.showVideoModal = false;
            this.$store.commit("TOGGLE_IS_MODAL_VIDEO", false);
          }, 800);
        }else {
          this.$store.commit("TOGGLE_IS_MODAL_VIDEO", true);
        }

        window.history.pushState({id:1}, null, null);
      }


    },


    updateHeaderState(){
      this.toggleMenuColor('black', 0.2, 0);
      // this.$gsap.to('.hideInAvatar', {opacity:1, duration:0.4});
    },

    updateHeaderStateBack(){

      if (this.content.white_logo) {
        this.toggleMenuColor("white", 0.2, 0.4);
      } else {
        this.toggleMenuColor("black", 0.2, 0.4);
      }
      // this.$gsap.to('.hideInAvatar', {opacity:0, duration:0.4});
    },

    customCategory(categories) {
      let returnCats = [];
      for (let i = 0; i < categories.length; i++) {
        const cat = categories[i];
        switch (cat) {
          case "awards":
            returnCats.push("Awards");
            break;
          case "news":
            returnCats.push("News");
            break;
          case "project-feature":
            returnCats.push("Project Feature");
            break;
          case "talk":
            returnCats.push("Talk");
            break;
          case "interview":
            returnCats.push("Interview");
            break;
          default:
            returnCats.push(cat);
        }
      }

      return returnCats;
    },

    cursorAnimations() {
      //cursor animation
      this.$gsap.set(".cursorPlay", { xPercent: -50, yPercent: -50 });

      const play = document.querySelector(".cursorPlay");
      const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
      const mouse = { x: pos.x, y: pos.y };
      const speed = 0.3;

      const fpms = 60 / 1000;

      const xSet = this.$gsap.quickSetter(play, "x", "px");
      const ySet = this.$gsap.quickSetter(play, "y", "px");

      window.addEventListener("mousemove", (e) => {
        mouse.x = e.x;
        mouse.y = e.y;
      });

      this.$gsap.ticker.add((time, deltaTime) => {
        const delta = deltaTime * fpms;
        const dt = 1.0 - Math.pow(1.0 - speed, delta);

        pos.x += (mouse.x - pos.x) * dt;
        pos.y += (mouse.y - pos.y) * dt;
        xSet(pos.x);
        ySet(pos.y);
      });
    },

    mouseEnter(){
      if (this.content.vimeo_id) {
        this.$gsap.to('.cursorPlay', {opacity:1, duration: 0.2});

        this.$gsap.to('.cursorPlay svg', {fill:'white', duration: 0});
      }

    },
    mouseLeave(){
      if (this.content.vimeo_id) {
        this.$gsap.to('.cursorPlay', {opacity:0, duration: 0.2});
      }
    },
  }
}
</script>

<style lang="scss">
.SingleService {
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  overflow-x: hidden;
  width: 100%;
  // background: pink;
  @include headerMargin;

  &__header {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: auto;
    @include marginBottom;

    &--image {
      width: 100%;
      height: auto;
      //aspect-ratio: 16/7;
    }

  }
    &__description {

    p {
     margin-bottom: 15px;
    }

    h2, h3 {
       margin-bottom: 15px;
      font-size: 22px;
      line-height: 1.1;
      font-variation-settings: 'wght' 600, 'wdth' 100, 'opsz' 30;

      @include desktop-sm {
        font-size: 30px;
      }

      @include desktop-l {
        font-size: 34px;
      }

      @include desktop-xl {
        font-size: 34px;
      }
    }

    li {
          position: relative;
          padding-left: 15px;
          list-style: none;

          @include desktop-sm {
              padding-left: 20px;
            }

          &::before {
            position: absolute;
            top: 12px;
            left: 0;
            content: '';
            background: $orange;
            transform: translateY(-50%);
            width: 8px;
            height: 8px;

            @include tablet {
              top: 15px;
            }

            @include desktop-sm {
              width: 10px;
              height: 10px;
              top: 17px;
            }

            @include desktop-l {
              top: 20px;
            }

            @include desktop-xl {
              top: 23px;
            }
          }
        }
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 100vw;
      overflow-x: hidden;
    // @include paddingTop;
    @include paddingMobile;
    @include paddingBottom;

    @include tablet {
      @include paddingBig;
    }
  }

  &__left {
    width: 100%;
     @include paddingMobileBottom;

     @include tablet-m {
      width: 35%;

     }
  }

  &__subtitle {
    display: flex;
    gap: 6px;
    margin-bottom: 5px;
  }

  &__title {
     font-size: 32px;
  line-height: 1;
  font-variation-settings: 'wght' 750, 'wdth' 100, 'opsz' 30;
  width: 100%;

  @include tablet {
        font-size: 48px;
    line-height: 1.1;
  }
    @include desktop-sm {
    font-size: 54px;
  }

  @include desktop-l {
    font-size: 64px;
  }

  @include desktop-xl {
    font-size: 74px;
  }

  }

  &__right {
    width: 100%;

    @include tablet-m {
      width: 55%;
      margin-top: 50px;
    }

    strong {
      color: $orange;
    }
  }

  .Related {
    width: 100%;
    @include paddingBottom;

    .section-title {
      // padding-top: 13vw;
      padding-bottom: 5vw;

      @include tablet {
        // padding-top: 7.7vw;
        padding-bottom: 2vw;
      }
    }

    &__container {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      @include paddingBig;

    }

    &__item {
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      overflow: hidden;
      width: 100%;
      @include marginBottomSmall;

      &:nth-child(3n) {
        margin-right: 0;
      }

       @include tablet {
        margin-right: 2.33%;
        //margin-bottom: 20px;
        width: 31.66%;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      &--image {
        width: 100%;


        @include desktop-s {
          transform: scale(1);
          transform-origin: center;
          @include transition;
        }

        &:hover {
          @include desktop-s {
            transform: scale(1.03);
          }
        }
      }
      &--image-container {
        position: relative;
        display: flex;
        flex-grow: 0;
         margin-bottom: 10px;
        overflow: hidden;
        aspect-ratio: 4/5;
      }


    }

    a {
      color: $grey;

      &:hover {
        color: $orange;
      }
    }


  }

 .playMobile {
        position: absolute;
        top: 50%;
        left: 50%;
        line-height: 0;
        transform: translate(-50%,-50%);

        img {
          height: 56px;
          width: auto;
        }

        svg {
          fill: $white;
          width: auto;
          height: 47px;
        }

      }

  // cursor options
.cursorPlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: none;
  pointer-events: none;
  opacity: 0;

  @include tablet {
    display: block;
  }

  svg {
    opacity: 1;
    fill: $white;
    height: 40px;
    width: auto;
  }

}
}
</style>
